import { render } from "./PhotoInputCropped.vue?vue&type=template&id=1d85e94a"
import script from "./PhotoInputCropped.vue?vue&type=script&lang=js"
export * from "./PhotoInputCropped.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__